import { useTranslation } from 'react-i18next'
import { isIssuedStatus } from '../../index.types'

// 重新导出类型，方便其他组件使用
export { CardStatus, ISSUED_CARD_STATUSES, isIssuedStatus } from '../../index.types'
export type { CardStatusType, IssuedCardStatus } from '../../index.types'

export interface CardViewProps {
  /** 卡片业务状态（后端返回的状态） */
  cardStatus?: string
  /** 是否已下卡 */
  cardIssued?: boolean
  /** 掩码卡号（后端直接返回掩码格式） */
  maskedPan?: string
  /** 余额（status=activated 时显示） */
  balance?: string | number
  /** 背景图片 */
  backgroundImage?: string
  /** 卡产品BIN（4位卡头，用于申请卡片时显示） */
  cardBin?: string
  /** 自定义类名 */
  className?: string
  /** 点击回调 */
  onClick?: () => void
}

const CardView: React.FC<CardViewProps> = ({
  cardStatus,
  cardIssued = false,
  maskedPan,
  balance,
  backgroundImage,
  cardBin,
  className = '',
  onClick
}) => {
  const { t } = useTranslation()

  // 格式化余额
  const formatBalance = (balance?: string | number) => {
    if (balance === undefined || balance === null) return '0.00'
    const num = typeof balance === 'string' ? parseFloat(balance) : balance
    return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  }

  // 默认背景图
  const bgImage = backgroundImage || '/images/card-v2/electronic-card/ap-card-1.png'

  // 判断是否展示余额：已下卡状态 + card_issued 为 true
  const shouldShowBalance = isIssuedStatus(cardStatus) && cardIssued
  
  // 卡号显示：cardBin 和 maskedPan 互斥，优先使用 cardBin（用于申请页面）
  const displayCardNumber = cardBin 
    ? `${cardBin.slice(0, 4)} **** **** ****` 
    : maskedPan

  return (
    <div 
      className={`aspect-[1.54] rounded-4 overflow-hidden relative ${className}`}
      onClick={onClick}
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* 卡号：cardBin 或 maskedPan */}
      {displayCardNumber && (
        <div className="absolute right-5 top-6.5 text-4 font-600 text-white">
          {displayCardNumber}
        </div>
      )}
      
      {/* 余额：仅已下卡状态显示 */}
      {shouldShowBalance && (
        <div className="absolute left-5 bottom-5">
          <div className="text-3 text-white/80 mb-1">{t('可用余额')}</div>
          <div className="text-5 font-600 text-white">{formatBalance(balance)}</div>
        </div>
      )}
    </div>
  )
}

export default CardView
